import { Injectable } from '@angular/core';
import { OrdersService, RmsOrderResponse, RmsOrderRequest } from '@cemex-core/cmx-api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { map, switchMap, catchError, filter, take } from 'rxjs/operators';
import {
  SimulateActionTypes,
  SimulateLoadCompleteAction,
  SimulateResetAction,
} from '@ordersnproducts/modules/order-builder/modules/rms-summary/actions/simulate.actions';
import { CmxClientService } from '@cemex/cmx-client-layout';
import { TranslateService } from '@ngx-translate/core';
import { RmsOrderRequestSolverService } from '@ordersnproducts/modules/order-builder/modules/rms-summary/solvers/rms-order-request-solver.service';
import { Mark } from '@ordersnproducts/modules/shared/constants/mark';
import { getActiveExperienceCode, OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { ORDER_EXPERIENCES } from '@ordersnproducts/modules/shared/constants/order-experiences';
import { Store } from '@ngrx/store';

@Injectable()
export class SimulateEffects {
  simulate$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType(SimulateActionTypes.LOAD),
      switchMap(() => {
        return this.store.select(getActiveExperienceCode).pipe(
          take(1),
          filter((expCode) => !expCode || expCode !== ORDER_EXPERIENCES.RMX_UNIVERSAL_LINK),
          switchMap(() => this.rmsOrderRequestSolverService.createRmsOrderRequest()),
          switchMap((request: RmsOrderRequest) => {
            this.alerts.addMainAlert('info', this.translate.instant('views.checkout.recovering_prices'));
            return this.ordersService.createRmsOrder(this.markAsSimulation(request)).pipe(
              map((order: RmsOrderResponse) => {
                this.alerts.closeAllAlerts();
                const taxes = Number(order.MT_Orders_resp.Orders[0].OrderTax);
                const netValue = Number(order.MT_Orders_resp.Orders[0].OrderNetValue);
                const total = taxes + netValue;
                const isValidPrice = total > 0;
                if (!isValidPrice) {
                  this.alerts.addMainAlert('danger', this.translate.instant('views.checkout.prices_error'));
                }

                return new SimulateLoadCompleteAction(order);
              }),
            );
          }),
          catchError((error) => {
            console.error(error);
            this.alerts.addMainAlert('danger', this.translate.instant('views.checkout.prices_error'));
            return of(new SimulateResetAction());
          }),
        );
      }),
    ),
  );

  markAsSimulation(request: RmsOrderRequest): RmsOrderRequest {
    return {
      ...request,
      testRun: Mark.MARK_AS_YES,
    };
  }

  constructor(
    private actions$: Actions,
    private alerts: CmxClientService,
    private ordersService: OrdersService,
    private translate: TranslateService,
    private rmsOrderRequestSolverService: RmsOrderRequestSolverService,
    private store: Store<OrderBuilderState>,
  ) {}
}
